const avatars = () => {
  const heroesItem = document.querySelectorAll('.avatars__item');

  const animationStart = (item) => {
    const el = item.querySelector('.avatars__item-content');
    const img = el.querySelector('img');

    const { imgStatic, imgAudio, imgAnimation } = el.dataset;

    if (item.classList.contains('avatars__item_play')) {
      return;
    }

    const audio = new Audio(imgAudio);

    audio.onloadedmetadata = () => {
      item.classList.add('avatars__item_play');
      const delay = Number((audio.duration * 1000).toFixed());
      img.src = imgAnimation;
      audio.play();
      setTimeout(() => {
        item.classList.remove('avatars__item_play');
        img.src = imgStatic;
        audio.remove();
      }, delay);
    };
  };

  heroesItem.forEach((item) => {
    ['click'].forEach((event) => {
      item.addEventListener(event, () => {
        animationStart(item);
      });
    });
  });
};

avatars();
